var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompleted = function SvgCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.258 15.78 2.092 9.565 0 11.674 8.258 20 26 2.11 23.908 0 8.258 15.78z"
  })));
};
export default SvgCompleted;